<template>
  <div class="upload-wrapper" :class="{ show: isUploadImg }">
    <div class="top">
      <span>请上传转账或者订单截图：</span>
      <span v-show="!buttonDisablie" @click="jump" class="jump">跳过></span>
    </div>
    <div class="bottom">
      <el-upload
        class="upload-area fl"
        :action="uploadApi"
        :on-change="handleEditChange"
        :class="{ hide: hideUploadEdit }"
        :headers="headers"
        list-type="picture-card"
        :on-exceed="handleExceed"
        :before-upload="beforeUpload"
        :on-success="handleSuccess"
        :on-remove="handleRemove"
        :on-error="handleError"
        :limit="limit"
        name="uploadFile"
        :data="params"
        :multiple="false"
        :drag="true"
        :file-list="fileList"
      >
        <i class="el-icon-plus avatar-uploader-icon"></i>
        <div slot="file" slot-scope="{ file }">
          <img
            class="el-upload-list__item-thumbnail"
            :src="file.url"
            alt="图片"
            @error="errorimg(file)"
          />
          <div v-if="file.status == 'success'" class="tip">上传成功</div>
          <div v-if="file.status == 'uploading'" class="tip">上传中</div>
          <span class="el-upload-list__item-actions">
            <span
              class="el-upload-list__item-delete"
              @click="handleRemove(file)"
            >
              <i class="el-icon-delete"></i>
            </span>
          </span>
        </div>
      </el-upload>
      <div
        v-show="buttonDisablie"
        class="primary-btn fr"
        @click="toMessage"
        :class="{ disabled: !buttonDisablie }"
      >
        完成，进入客服
      </div>
    </div>
  </div>
</template>

<script>
//上传截图或者转账截图组件
import transferUploadImg from "src/mixins/transferUploadImg";
export default {
  name: "uploadImg-model",
  mixins: [transferUploadImg],
  computed: {
    ...mapState({
      isUploadImg: state => state.isUploadImg
    })
  },
  data() {
    return {
      hideUploadEdit: false,
      limit: 5
    };
  },
  methods: {
    ...mapActions({
      initChannel: "initChannel"
    }),
    errorimg(file) {
      this.$message.error("文件无效（0kb）或格式不正确，请重新选择正确文件");
      this.handleRemove(file);
    },
    removeImg() {
      clearTimeout(this.time);
      this.time = setTimeout(() => {
        this.hideUploadEdit = this.fileList.length >= this.limit;
      }, 500);
    },
    handleEditChange(file, fileList) {
      this.fileList = fileList;
      console.log(file, fileList, fileList.length);
      this.hideUploadEdit = fileList.length >= this.limit;
    },
    jump() {
      if (this.fileList.length == 0) {
        this.canClick = true;
      }
      if (!this.canClick) {
        this.$message.warning("请等待图片上传完成");
        return;
      }
      let orderImgUrls = [];
      for (let key in this.listObj) {
        orderImgUrls.push(this.listObj[key]);
      }
      orderImgUrls = orderImgUrls.join(",");
      this.$store.commit("setState", {
        isUploadImg: false,
        orderImgUrls,
        isBeforeConnect: false,
        isJump: true
      });
      // this.$store.commit("chat/setState", {
      //   messageMap: []
      // }); //清空消息

      this.$store.commit("clearAllMessages");

      this.initChannel({ orderImgUrls: "", router: this.$router });
      this.$router.push("/conversation");
    },
    toMessage() {
      // if(this.fileList.length==)
      if (this.buttonDisablie) {
        this.fileList.forEach((element, i) => {
          if (element.status === "ready") {
            delete this.fileList[i];
          }
        });
        let j = 0;
        this.fileList.forEach(element => {
          if (element.status != "success") {
            this.canClick = false;
            return false;
          } else if (element.status == "success") {
            j++;
          }
        });

        if (this.fileList.length == j) {
          this.canClick = true;
        }
        if (!this.canClick) {
          this.$message.warning("请等待图片上传完成");
          return;
        }
        let orderImgUrls = [];
        for (let key in this.listObj) {
          orderImgUrls.push(this.listObj[key]);
        }
        orderImgUrls = orderImgUrls.join(",");
        this.$store.commit("setState", {
          isUploadImg: false,
          orderImgUrls,
          isBeforeConnect: false,
          isJump: true
        });
        this.$store.commit("clearAllMessages");

        // this.initChannel({ orderImgUrls });
        // this.$router.push("/conversation");
        this.initChannel({ orderImgUrls, router: this.$router });
        this.$router.push("/conversation");
      }
    }
  }
};
</script>

<style scoped lang="less">
.tip {
  color: #fff;
  z-index: 64;
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 16px;
  line-height: 16px;
  font-size: 12px;
  text-align: center;
  background: rgba(0, 0, 0, 0.8);
}
.upload-wrapper {
  width: 100%;
  padding: 0 15px;
  background-color: #fff;
  transition-duration: 0.3s;
  visibility: hidden;
  height: 0;
  opacity: 0;

  &.show {
    visibility: visible;
    height: auto;
    min-height: 120px;
    opacity: 1;
  }

  .el-upload {
    display: inline-flex;
    width: 70px;
    height: 70px;
    justify-content: center;
    align-items: center;
    .el-icon-plus {
      color: var(--loadimg-add-icon);
      &:active {
        color: var(--loadimg-add-click);
      }
    }
  }

  .el-upload-list__item {
    width: 60px;
    height: 60px;
    position: relative;
    img {
      max-width: 100%;
      height: auto;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
    }
  }

  .el-upload--picture-card {
    border: 0px dashed var(--loadimg-add-icon);
    i {
      color: #3a88ef;
    }
    &:active {
      border: 0px dashed var(--loadimg-add-click);
    }
  }
}
.upload-wrapper {
  width: 100%;
  padding: 0 15px;
  background-color: #fff;
  transition-duration: 0.3s;
  visibility: hidden;
  height: 0;
  opacity: 0;

  &.show {
    visibility: visible;
    height: auto;
    min-height: 120px;
    opacity: 1;
  }

  .top {
    display: flex;
    height: 30px;
    justify-content: space-between;
    align-items: center;
    line-height: 20px;

    .jump {
      color: var(--header-bg);
      cursor: pointer;
      &:active {
        color: var(--header-bg);
      }
    }

    span {
      font-size: 14px;

      &:first-of-type {
        color: #1e1e1e;
      }
    }
  }

  .bottom {
    display: flex;
    height: auto;
    min-height: 90px;
    justify-content: space-between;
    align-items: center;

    /deep/ .el-upload {
      display: inline-flex;
      width: 70px;
      height: 70px;
      justify-content: center;
      align-items: center;
      .el-icon-plus {
        color: var(--loadimg-add-icon);
        &:active {
          color: var(--loadimg-add-click);
        }
      }
    }

    /deep/ .el-upload-list__item {
      width: 60px;
      height: 60px;
      position: relative;
      img {
        max-width: 100%;
        height: auto;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
      }
    }

    /deep/ .el-upload--picture-card {
      border: 0px dashed var(--loadimg-add-icon);
      i {
        color: #3a88ef;
      }
      &:active {
        border: 0px dashed var(--loadimg-add-click);
      }
      .el-upload-dragger {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        // border: 0;
      }
    }
  }

  .primary-btn {
    min-width: 120px;
    white-space: nowrap;
    height: 35px;
    border-radius: 4px;
    line-height: 35px;
    text-align: center;
    font-size: 14px;
    background: var(--button-bg) !important;
    color: var(--button-text) !important;
    &:active {
      background: var(--button-click) !important;
      color: var(--button-text-click) !important;
    }
  }
  .disabled {
    opacity: 0.4;
  }
}
</style>
